/* eslint-disable jsx-a11y/img-redundant-alt */
import React from 'react';
import './css/Pets.css';

const pets = [
  {
    id: 0,
    name: 'Finn',
    description: 'He was a good boy',
    images: ['1.jpg', '2.jpg', '3.jpg'],
  },
  {
    id: 1,
    name: 'Toby',
    description: 'He is a good boy',
    images: ['1.jpg', '2.jpg'],
  },
  { id: 2, name: 'Remy', description: 'He is a good boy', images: ['1.jpg'] },
  {
    id: 4,
    name: 'Sparky',
    description:
      'Sparky was a young white and grey, tabby cat and was a good boy',
    images: [],
  },
];

const PetsComponent = () => {
  return (
    <main className="os-main">
      <section
        className="os-home-card"
        style={{ maxWidth: '100%', padding: '0' }}
      >
        <div style={{ padding: '2rem' }}>
          <h1 className="os-title" style={{ marginBottom: '0.5rem' }}>
            My Pets
          </h1>
          <p className="os-desc" style={{ marginBottom: '2rem' }}>
            Meet the good boys and girls 🐾
          </p>
          <hr className="hrStyle1" style={{ marginBottom: '2rem' }} />
        </div>

        <div className="os-pets-grid">
          {pets.map((pet) => (
            <div key={pet.id} className="os-pet-card">
              <div className="os-pet-header">
                <h2 className="os-pet-name">{pet.name}</h2>
              </div>

              {pet.images && pet.images.length > 0 ? (
                <div className="os-pet-gallery">
                  {pet.images.map((image, index) => (
                    <img
                      key={`${pet.name}-${index}`}
                      src={`/assets/pets/${pet.name}/${image}`}
                      alt={`${pet.name} Image ${index + 1}`}
                      className="os-pet-image"
                    />
                  ))}
                </div>
              ) : (
                <div className="os-pet-gallery-empty">
                  <p style={{ color: 'var(--tb-fg-dim, #aaaaaa)' }}>No photos available</p>
                </div>
              )}

              <div className="os-pet-footer">
                <p className="os-pet-description">{pet.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
};

export default PetsComponent;
